/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-28 15:40:04
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-03-28 15:40:39
 * @FilePath: src/utils/auth.ts
 * @Description: TypeScript版本 - 自动转换
 */

import Cookies from 'js-cookie'
import { removeCookie, setCookie } from '@/utils/cookie'

const TokenKey = 'Admin-Token-Flag'

export function getToken(): any {
  return Cookies.get(TokenKey)
}

export function setToken(token: any = '1'): any {
  removeCookie('Admin-Token')
  return setCookie(TokenKey, token, { expires: 1 })
}

export function removeToken(): any {
  removeCookie('Admin-Token')
  return removeCookie(TokenKey)
}
